import axios from "axios";
import { ActiveExperimentsResponse } from "redmond";
import { platformApiApi } from "@capone/platform-api";

import { config } from "../../config";

export const fetchActiveExperiments = async (): Promise<ActiveExperimentsResponse> => {
  const res = await platformApiApi(axios).apiV0ExperimentsActivePut({
    baseURL: config.baseURL,
  });
  return res.data as unknown as ActiveExperimentsResponse;
};
